import { BalButton } from "@baloise/ds-react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React, { PropsWithChildren, useState } from "react";

const Accordion = ({ children }: PropsWithChildren) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { t } = useTranslation();

    return (
        <div>
            <div
                data-testid="accordion"
                className={`${isOpen ? "block" : "hidden"}`}
            >
                {children}
            </div>
            <BalButton
                flat
                color="link"
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
                data-testid="toggle"
            >
                {isOpen ? t("info.less") : t("info.more")}
            </BalButton>
        </div>
    );
};
export default Accordion;
